export default "__VITE_ASSET__BcF4J7Dt__"